import { useState, useEffect  } from "react";

export default function Series_List({
  seriesListObj,
  fillSelectionWithList,
  createWholeSeries,
  duplicateSelectionArray,
  fillWithListSelectionArray,
}) {
  const [canDuplicate, setCanDuplicate] = useState(false);
  const [canFill, setCanFill] = useState(false);


  useEffect(() => {
    if (duplicateSelectionArray.length === 1) {
      setCanDuplicate(true);
    } else {
      setCanDuplicate(false);
    }
  }, [duplicateSelectionArray, fillWithListSelectionArray]);

  useEffect(() => {
    if (fillWithListSelectionArray.length >= 1) {
      setCanFill(true);
    } else {
      setCanFill(false);
    }
  }, [duplicateSelectionArray, fillWithListSelectionArray]);

 

  return (
    <div id="series-list" className="grid mt-0 pb-0">
      <div className="grid cs1 ce12 mt-0">
        <div id="series-list-header" className="cs1 ce9 cursor-pointer pt-8">
          <p className="p-medium mt-0 mb-0">
            <b>{seriesListObj.demo}</b>
          </p>
          <p className="p-small mt-0 mb-0 softer-help">{seriesListObj.title}</p>
        </div>
        <button
          type="button"
          disabled={!canFill}
          className="cs10 mb-0 thin-button"
          // disabled={selections.length === 0}
          onClick={(event) => {
            fillSelectionWithList(seriesListObj);
          }}>
          Fill
          {/* <span class="tooltiptext">Tooltip text</span> */}
        </button>
        <button
          type="button"
          disabled={!canDuplicate}
          className="cs11 thin-button"
          onClick={(event) => {
            createWholeSeries(seriesListObj);
          }}>
          All
          {/* <span class="tooltiptext">Tooltip text</span> */}
        </button>
      </div>
    </div>
  );
}
